import React from "react";

import { Row, Col, Input, Select, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Contact/ContactUs.css";

const companyAddressCard = {
    borderRadius: "20px",
    backgroundColor: "#fff",
    opacity: "95%",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}
const companyCardText = {
    fontSize: ".9em",
    fontFamily: "IranSans",
    textAlign: "right",
    direction: "rtl",
    lineHeight: 1.5,
    color: "#535353",
    marginTop: "20px"
}
const companyCardTextTablet = {
    fontSize: ".85em",
    fontFamily: "IranSans",
    textAlign: "right",
    direction: "rtl",
    lineHeight: 1.5,
    color: "#535353",
    marginTop: "15px"
}
const companyCardTextMobile = {
    fontSize: ".8em",
    fontFamily: "IranSans",
    textAlign: "right",
    direction: "rtl",
    lineHeight: 1.5,
    color: "#535353",
    marginTop: "10px"
}

const CompaniesAddress = props => {
    return props.size === "laptopdesktop" ? (
        <div>
            <Row>
                <Col span={3}></Col>
                <Col span={18}>
                    <div style={companyAddressCard}>
                        <Row>
                            <Col span={12} style={{ textAlign: "center", backgroundColor: "#f5f5f5", borderRadius: "20px 0 0 20px" }}>
                                <Center>
                                    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div class="mapouter"><div class="gmap_canvas"><iframe width="400" height="300" id="gmap_canvas" src={props.map} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://www.embedgooglemap.net/en/"></a></div></div>
                                    </div>
                                </Center>
                            </Col>
                            <Col span={12}>
                                <div style={{ backgroundColor: "#fff", borderRadius: "0 20px 20px 0", height: "340px" }}>
                                    <Row>
                                        <Col span={20} style={{ direction: "rtl", textAlign: "right" }}>
                                            <p style={{
                                                fontSize: ".9em",
                                                fontFamily: "IranSans",
                                                textAlign: "right",
                                                direction: "rtl",
                                                lineHeight: 1.5,
                                                color: "#535353",
                                                marginTop: "30px"
                                            }}>
                                                {props.address}
                                            </p>
                                        </Col>
                                        <Col span={4}>
                                            <img
                                                style={{ width: "65%", marginTop: "15px" }}
                                                src={require("../../../Imgs/ContactUs/Location.png")}
                                            />
                                        </Col>
                                    </Row>
                                    <Margin top={2}></Margin>
                                    <Row>
                                        <Col span={4}></Col>
                                        <Col span={8}>
                                            <p style={companyCardText}>
                                                {props.fax}
                                            </p>
                                        </Col>
                                        <Col span={8}>
                                            <p style={companyCardText}>
                                                {props.phone}
                                            </p>
                                        </Col>
                                        <Col span={4}>
                                            <img
                                                style={{ width: "65%" }}
                                                src={require("../../../Imgs/ContactUs/phone.png")}
                                            />
                                        </Col>
                                    </Row>
                                    <Margin top={2}></Margin>
                                    <Row>
                                        <Col span={20}>
                                            <p style={companyCardText}>
                                                {props.mail}
                                            </p>
                                        </Col>
                                        <Col span={4}>
                                            <img
                                                style={{ width: "65%" }}
                                                src={require("../../../Imgs/ContactUs/support.png")}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </Col>
                <Col span={3}></Col>
            </Row>
        </div>
    ) : props.size === "tablet" ? (
            <div>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div style={companyAddressCard}>
                            <Row>
                                
                                <Col span={24}>
                                    <div style={{ backgroundColor: "#fff", borderRadius: "20px"}}>
                                        <Row>
                                            <Col span={20} style={{ direction: "rtl", textAlign: "right" }}>
                                                <p style={{
                                                    fontSize: ".85em",
                                                    fontFamily: "IranSans",
                                                    textAlign: "right",
                                                    direction: "rtl",
                                                    lineHeight: 1.5,
                                                    color: "#535353",
                                                    marginTop: "20px"
                                                }}>
                                                    {props.address}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "45%", marginTop: "15px" }}
                                                    src={require("../../../Imgs/ContactUs/Location.png")}
                                                />
                                            </Col>
                                        </Row>
                                        <Margin top={2}></Margin>
                                        <Row>
                                            <Col span={4}></Col>
                                            <Col span={8}>
                                                <p style={companyCardTextTablet}>
                                                    {props.fax}
                                                </p>
                                            </Col>
                                            <Col span={8}>
                                                <p style={companyCardTextTablet}>
                                                    {props.phone}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "45%" }}
                                                    src={require("../../../Imgs/ContactUs/phone.png")}
                                                />
                                            </Col>
                                        </Row>
                                        <Margin top={2}></Margin>
                                        <Row>
                                            <Col span={20}>
                                                <p style={companyCardTextTablet}>
                                                    {props.mail}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "45%" }}
                                                    src={require("../../../Imgs/ContactUs/support.png")}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                                
                            <Center>
                                <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <div class="mapouter"><div class="gmap_canvas"><iframe width="400" height="300" id="gmap_canvas" src={props.map} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://www.embedgooglemap.net/en/"></a></div></div>
                                </div>
                            </Center>
                               

                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>

    ) : (
                <div>
                    <Row>
                        <Col span={1}></Col>
                        <Col span={22}>
                            <Card style={{borderRadius:"20px"}}>
                                <Row>
                                        <Row>
                                            <Col span={20} style={{ direction: "rtl", textAlign: "right" }}>
                                                <p style={{
                                                    fontSize: ".8em",
                                                    fontFamily: "IranSans",
                                                    textAlign: "right",
                                                    direction: "rtl",
                                                    lineHeight: 1.5,
                                                    color: "#535353",
                                                    marginTop: "20px"
                                                }}>
                                                    {props.address}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "65%", marginTop: "15px" }}
                                                    src={require("../../../Imgs/ContactUs/Location.png")}
                                                />
                                            </Col>
                                        </Row>
                                        <Margin top={2}></Margin>
                                        <Row>
                                            <Col span={4}></Col>
                                            <Col span={8}>
                                                <p style={companyCardTextMobile}>
                                                    {props.fax}
                                                </p>
                                            </Col>
                                            <Col span={8}>
                                                <p style={companyCardTextMobile}>
                                                    {props.phone}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "65%" }}
                                                    src={require("../../../Imgs/ContactUs/phone.png")}
                                                />
                                            </Col>
                                        </Row>
                                        <Margin top={2}></Margin>
                                        <Row>
                                            <Col span={20}>
                                                <p style={companyCardTextMobile}>
                                                    {props.mail}
                                                </p>
                                            </Col>
                                            <Col span={4}>
                                                <img
                                                    style={{ width: "65%" }}
                                                    src={require("../../../Imgs/ContactUs/support.png")}
                                                />
                                            </Col>
                                        </Row>
                                </Row>
                                <Margin top={2}></Margin>
                                <Row>
                                    <Col span={1}></Col>
                                    <Col span={22}>
                                        <Center>
                                                <div class="mapouter"><div class="gmap_canvas"><iframe width="250" height="250" id="gmap_canvas" src={props.map} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://www.embedgooglemap.net/en/"></a></div></div>
                                        </Center>
                                    </Col>
                                    <Col span={1}></Col>
                                </Row>
                            </Card>
                            <Margin bottom={4}></Margin>

                        </Col>
                        <Col span={1}></Col>
                    </Row>
                </div>
            );
};

export default CompaniesAddress;
